import { render, staticRenderFns } from "./ChangePasswordAccelerate.vue?vue&type=template&id=9e4b8b3a&"
import script from "./ChangePasswordAccelerate.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordAccelerate.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordAccelerate.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports